import React, { FC, useState, useEffect } from 'react';
import { TableRowType, RowActionPropsType } from 'src/types/table';
import { ActionType, getActionElement } from '../ActionsMenu';

type TableRowActionsPropsType = {
    row: TableRowType;
    rowActions?: RowActionPropsType[];
    handlePopupOpen?: (value: boolean) => void;
};

const TableRowActions: FC<TableRowActionsPropsType> = (props) => {
    const [rowEnableActions, setRowEnableActions] = useState<RowActionPropsType[]>([]);

    useEffect(() => {
        setRowEnableActions(
            props.rowActions
                ? props.rowActions.filter((actionItem) =>
                      actionItem.hiddenFce ? !actionItem.hiddenFce(props.row) : true
                  )
                : []
        );
    }, [props.rowActions, props.row]);

    const transferAction = (action: RowActionPropsType): ActionType => ({
        icon: action.icon,
        label: action.label,
        tooltip: action.tooltip,
        style: action.style,
        onClick: action.onClick ? () => action.onClick?.(props.row) : undefined,
        getLink: action.getLink ? () => action.getLink?.(props.row) || '' : undefined,
        hiddenFce: action.hiddenFce ? () => action.hiddenFce?.(props.row) || false : undefined,
    });

    const handleClickItem = (actionItem: ActionType) => {
        actionItem.onClick?.();
    };

    if (!rowEnableActions.length) {
        return null;
    }

    return (
        <div className="row-actions-inline">
            {[...rowEnableActions].reverse().map((action, index) => (
                <React.Fragment key={index}>
                    {getActionElement(transferAction(action), handleClickItem) || null}
                </React.Fragment>
            ))}
        </div>
    );
};

export default TableRowActions;
